var React = require('react');

function TriangleSmall (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"triangle-small_Designs","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"triangle-small_Curriculum---v3","transform":"translate(-1073.000000, -330.000000)","fill":"currentColor"},React.createElement("g",{"id":"triangle-small_Filters","transform":"translate(76.000000, 321.000000)"},React.createElement("g",{"id":"triangle-small_Filter:-subject","transform":"translate(878.000000, 4.000000)"},React.createElement("g",{"id":"triangle-small_Style-Copy-2"},React.createElement("polygon",{"id":"triangle-small_Rectangle","points":"119 5 131 5 125 11"})))))));
}

TriangleSmall.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 12 6","version":"1.1"};

module.exports = TriangleSmall;

TriangleSmall.default = TriangleSmall;
